import React from 'react';
import PropTypes from 'prop-types';
import StructuredContent from '@nerdwallet/structured-content';
import { stringInputSpec, boolCheckboxSpec } from '../../lib/editing-configs';

const TravelInsuranceEntryPointWrapper = ({
  ctaText,
  ctaAnnotation,
  redirectUrl,
  showAdPill,
}) => {
  return (
    <StructuredContent>
      {{
        type: 'TravelInsuranceEntryPoint',
        version: '1.0.0',
        props: {
          ctaText,
          ctaAnnotation,
          redirectUrl,
          showAdPill,
        },
      }}
    </StructuredContent>
  );
};

TravelInsuranceEntryPointWrapper.propTypes = {
  /** Text on the CTA */
  ctaText: PropTypes.string,
  /** Text displayed below the CTA */
  ctaAnnotation: PropTypes.string,
  /** Custom redirect URL for the CTA */
  redirectUrl: PropTypes.string,
  /** Wether to show or not the ad pill */
  showAdPill: PropTypes.bool,
};

TravelInsuranceEntryPointWrapper.defaultProps = {
  ctaText: 'Search for policies',
  ctaAnnotation: 'on NerdWallet',
  showAdPill: true,
};

TravelInsuranceEntryPointWrapper.getEditingConfig = () => {
  return [
    stringInputSpec('ctaText', 'CTA Text'),
    stringInputSpec('ctaAnnotation', 'CTA Annotation'),
    stringInputSpec('redirectUrl', 'Redirect URL'),
    boolCheckboxSpec('showAdPil', 'Show Ad Pil'),
  ];
};

TravelInsuranceEntryPointWrapper.displayName =
  'TravelInsuranceEntryPointWrapper';

export default TravelInsuranceEntryPointWrapper;
